import { handleActions } from 'redux-actions';
import { createSelector } from '@reduxjs/toolkit';
import {
  CREATE_NOTIFICATION_TEMPLATE, EDIT_NOTIFICATION_TEMPLATE_BY_ID, LOAD_NOTIFICATION_TEMPLATE_BY_ID,
  LOAD_OF_INSURANCE_COMPANIES_LIST,
  LOAD_OF_NOTIFICATION_TEMPLATE_REGISTRY_LIST, LOAD_REASON_LIST,
  LOAD_REGISTER_OF_SUSPENSION_RESPONSE_LIST, LOAD_REGISTRY_OF_SUSPENSION_REASONS_BY_ID, LOAD_USER_ACTION_BY_ID,
  LOAD_USER_ACTION_LIST,
  LOAD_TEMPLATE_HELPER_DATA, LOAD_REASON_LIST_ALL,
} from './actions';
import { REFERENCE_INFORMATION_MODULE } from '../../configs/moduleNames';
import {
  createLoadByIdReducer,
  createLoadListReducerWithBegin, createLoadParameterReducer, createOperationStateReducer,
} from '../../utils/getCrudConfig';

const initialState = {
  userActivityLogListMeta: {},
  loadingUserActivityLogList: false,
  userActivityLogList: [],
  loadingCurrentUserActivity: false,
  currentUserActivity: {},
  insuranceCompaniesList: [],
  loadingListOfInsuranceCompaniesList: false,
  insuranceCompaniesListMeta: {},
  registryOfSuspensionReasonsList: [],
  loadingRegistryOfSuspensionReasonsList: false,
  registryOfSuspensionReasonsListMeta: {},
  notificationTemplateRegistryListMeta: {},
  notificationTemplateRegistryList: [],
  loadingNotificationTemplateRegistry: false,
  reasonListMeta: {},
  loadingReasonList: false,
  reasonList: [],
  loadingCreateNotification: false,
  loadingEditNotification: false,
  loadingCurrentNotificationTemplate: false,
  currentNotificationTemplate: {},
  loadingRegistryOfSuspensionReasons: false,
  registryOfSuspensionReasons: {},
  loadingTemplateHelperData: false,
  templateHelperData: {},
  reasonListAll: [],
  loadingReasonListAll: false,
};

const reducer = handleActions({
  ...createLoadListReducerWithBegin(REFERENCE_INFORMATION_MODULE + LOAD_USER_ACTION_LIST, 'userActivityLogList', 'loadingUserActivityLogList'),
  ...createLoadListReducerWithBegin(REFERENCE_INFORMATION_MODULE + LOAD_OF_INSURANCE_COMPANIES_LIST, 'insuranceCompaniesList', 'loadingListOfInsuranceCompaniesList'),
  ...createLoadListReducerWithBegin(REFERENCE_INFORMATION_MODULE + LOAD_REGISTER_OF_SUSPENSION_RESPONSE_LIST, 'registryOfSuspensionReasonsList', 'loadingRegistryOfSuspensionReasonsList'),
  ...createLoadListReducerWithBegin(REFERENCE_INFORMATION_MODULE + LOAD_OF_NOTIFICATION_TEMPLATE_REGISTRY_LIST, 'notificationTemplateRegistryList', 'loadingNotificationTemplateRegistry'),
  ...createLoadListReducerWithBegin(REFERENCE_INFORMATION_MODULE + LOAD_REASON_LIST, 'reasonList', 'loadingReasonList'),
  ...createLoadListReducerWithBegin(REFERENCE_INFORMATION_MODULE + LOAD_REASON_LIST_ALL, 'reasonListAll', 'loadingReasonListAll'),
  ...createOperationStateReducer(REFERENCE_INFORMATION_MODULE + CREATE_NOTIFICATION_TEMPLATE, 'loadingCreateNotification'),
  ...createOperationStateReducer(REFERENCE_INFORMATION_MODULE + EDIT_NOTIFICATION_TEMPLATE_BY_ID, 'loadingEditNotification'),
  ...createLoadByIdReducer(REFERENCE_INFORMATION_MODULE + LOAD_NOTIFICATION_TEMPLATE_BY_ID, 'currentNotificationTemplate', 'loadingCurrentNotificationTemplate'),
  ...createOperationStateReducer(REFERENCE_INFORMATION_MODULE + CREATE_NOTIFICATION_TEMPLATE, 'loadingCreateNotification'),
  ...createOperationStateReducer(REFERENCE_INFORMATION_MODULE + EDIT_NOTIFICATION_TEMPLATE_BY_ID, 'loadingEditNotification'),
  ...createLoadByIdReducer(REFERENCE_INFORMATION_MODULE + LOAD_REGISTRY_OF_SUSPENSION_REASONS_BY_ID, 'registryOfSuspensionReasons', 'loadingRegistryOfSuspensionReasons'),
  ...createLoadByIdReducer(REFERENCE_INFORMATION_MODULE + LOAD_USER_ACTION_BY_ID, 'currentUserActivity', 'loadingCurrentUserActivity'),
  ...createLoadParameterReducer(REFERENCE_INFORMATION_MODULE + LOAD_TEMPLATE_HELPER_DATA, 'templateHelperData', 'loadingTemplateHelperData', {}),
}, initialState);

export default reducer;

export const getReferenceInformationData = createSelector(
  [state => state[REFERENCE_INFORMATION_MODULE]],
  state => {
    const {
      userActivityLogListMeta,
      loadingUserActivityLogList,
      userActivityLogList,
      insuranceCompaniesList,
      loadingListOfInsuranceCompaniesList,
      insuranceCompaniesListMeta,
      registryOfSuspensionReasonsList,
      loadingRegistryOfSuspensionReasons,
      registryOfSuspensionReasonsListMeta,
      notificationTemplateRegistryList,
      notificationTemplateRegistryListMeta,
      loadingNotificationTemplateRegistry,
      loadingRegistryOfSuspensionReasonsList,
      reasonListMeta,
      loadingReasonList,
      reasonList,
      loadingCreateNotification,
      loadingEditNotification,
      loadingCurrentNotificationTemplate,
      currentNotificationTemplate,
      registryOfSuspensionReasons,
      currentUserActivity,
      loadingCurrentUserActivity,
      loadingTemplateHelperData,
      templateHelperData,
      reasonListAll,
      loadingReasonListAll,
    } = state;
    return {
      reasonListAll,
      loadingReasonListAll,
      currentUserActivity,
      loadingCurrentUserActivity,
      userActivityLogListMeta,
      loadingUserActivityLogList,
      userActivityLogList,
      insuranceCompaniesList,
      loadingListOfInsuranceCompaniesList,
      insuranceCompaniesListMeta,
      registryOfSuspensionReasonsList,
      loadingRegistryOfSuspensionReasonsList,
      registryOfSuspensionReasonsListMeta,
      notificationTemplateRegistryListMeta,
      notificationTemplateRegistryList,
      loadingNotificationTemplateRegistry,
      reasonListMeta,
      loadingReasonList,
      reasonList,
      loadingCreateNotification,
      loadingEditNotification,
      loadingCurrentNotificationTemplate,
      currentNotificationTemplate,
      loadingRegistryOfSuspensionReasons,
      registryOfSuspensionReasons,
      loadingTemplateHelperData,
      templateHelperData,
    };
  },
);
